import { useEffect, useState } from "react";
import classNames from "classnames";

import { DatoImage } from "components/image/datoImage";
import CardContainer from "./cardContainer";
import Heading from "./heading";
import useSiftedMediaQueries from "lib/hooks/useSiftedMediaQueries";
import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";
import { LazyIframe } from "components/lazyIframe/lazyIframe";

const TrackedCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  const { mobile } = useSiftedMediaQueries();
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <CardContainer id={`content__${id}`}>
      <Heading text={briefing.trackedHeading} id={id} />

      {briefing.trackedFigures.map((figure, i) => {
        if (Object.keys(figure).length === 0) return null;

        if (figure.hasOwnProperty("flourishId")) {
          return (
            <div key={i} className="mb-6 w-100 md:mb-8">
              {figure.heading && (
                <h2 className="mb-[16px] text-[20px] font-[700] md:text-[24px]">
                  {figure.heading}
                </h2>
              )}
              <LazyIframe
                title="Interactive or visual content"
                src={`https://flo.uri.sh/visualisation/${figure.flourishId}/embed`}
                className="flourish-embed-iframe"
                frameBorder="0"
                scrolling="no"
                style={{ width: "100%", height: "580px" }}
              ></LazyIframe>
            </div>
          );
        }
        return (
          <div
            key={i}
            className={classNames("md:mt-[16px]", {
              "mt-[32px]": i !== 0,
              "mt-[16px]": i === 0,
            })}
          >
            <p className="mb-[16px] text-[20px] font-[700] md:text-[24px]">
              {figure.heading}
            </p>

            {mobile && isHydrated && figure.mobileImage?.url ? (
              <DatoImage
                containerClassName="inline-block w-100 h-100 max-w-[380px]"
                layout="responsive"
                src={figure.mobileImage?.url}
                width={figure.mobileImage?.width}
                height={figure.mobileImage?.height}
                blurDataURL={figure.mobileImage?.blurUpThumb}
                placeholder="blur"
                alt={figure.heading}
              />
            ) : (
              figure.desktopImage?.url && (
                <DatoImage
                  containerClassName="max-w-[850px]"
                  src={figure.desktopImage?.url}
                  width={figure.desktopImage?.width}
                  height={figure.desktopImage?.height}
                  blurDataURL={figure.desktopImage?.blurUpThumb}
                  placeholder="blur"
                  alt={figure.heading}
                />
              )
            )}
          </div>
        );
      })}
    </CardContainer>
  );
};

export default TrackedCard;
